import React, { useState } from 'react';
import './Partners.css';

const partners = [
  { id: 1, name: "Kenya Power", logo: "/images/partners/partner-1.png", initials: "KP", area: "Power Distribution" },
  { id: 2, name: "SolarTech Solutions", logo: "/images/partners/partner-2.png", initials: "ST", area: "Solar Energy" },
  { id: 3, name: "BuildRight Construction", logo: "/images/partners/partner-3.png", initials: "BR", area: "Construction" },
  { id: 4, name: "SecureNet Systems", logo: "/images/partners/partner-4.png", initials: "SN", area: "Security Systems" },
  { id: 5, name: "Green Energy Africa", logo: "/images/partners/partner-5.png", initials: "GE", area: "Renewable Energy" },
  { id: 6, name: "TechPro Electric", logo: "/images/partners/partner-6.png", initials: "TP", area: "Electrical Supplies" },
  { id: 7, name: "SafeGuard Alarms", logo: "/images/partners/partner-7.png", initials: "SG", area: "Security Solutions" },
  { id: 8, name: "PowerBox Distributors", logo: "/images/partners/partner-8.png", initials: "PD", area: "Distribution" }
];

const Partners = () => {
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({
    companyName: '', contactPerson: '', email: '', phone: '',
    partnershipArea: '', companyDescription: ''
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    setFormData({ companyName: '', contactPerson: '', email: '', phone: '', partnershipArea: '', companyDescription: '' });
    setTimeout(() => { setSubmitted(false); setShowForm(false); }, 3000);
  };

  const partnershipAreas = [
    "Power Distribution", "Solar Energy", "Construction", "Security Systems",
    "Renewable Energy", "Electrical Supplies", "Network Infrastructure", "Other"
  ];

  return (
    <section className="partners-section">
      <div className="partners-container">
        <div className="partners-header">
          <h4 className="partners-subtitle">Our Partners</h4>
          <h1 className="partners-title">Trusted By Industry Leaders</h1>
          <p className="partners-description">
            We collaborate with leading companies and organizations to deliver 
            exceptional electrical services and solutions.
          </p>
        </div>

        {/* Partners Cards Grid */}
        <div className="partners-names">
          {partners.map((partner, index) => (
            <div className="partner-card slide-up" key={partner.id} style={{ animationDelay: `${index * 0.1}s` }}>
              <div className="partner-card-logo">
                <img 
                  src={process.env.PUBLIC_URL + partner.logo} 
                  alt={partner.name}
                  className="card-logo-img"
                  onError={(e) => { e.target.style.display = 'none'; e.target.nextElementSibling.style.display = 'flex'; }}
                />
                <div className="card-logo-fallback">{partner.initials}</div>
              </div>
              <div className="partner-card-info">
                <span className="partner-name-text">{partner.name}</span>
                <span className="partner-area">{partner.area}</span>
              </div>
            </div>
          ))}
        </div>

        {/* Partner With Us Button */}
        <div className="partner-cta">
          <button className="partner-btn" onClick={() => setShowForm(true)}>
            Partner With Us
          </button>
        </div>
      </div>

      {/* Partner Form Modal */}
      {showForm && (
        <div className="partner-form-overlay" onClick={() => setShowForm(false)}>
          <div className="partner-form-modal" onClick={(e) => e.stopPropagation()}>
            <button className="form-close" onClick={() => setShowForm(false)}>✕</button>
            
            {submitted ? (
              <div className="form-success">
                <span className="success-icon">✓</span>
                <h3>Thank You!</h3>
                <p>Your partnership request has been submitted. We'll get back to you shortly.</p>
              </div>
            ) : (
              <>
                <h2>Become a Partner</h2>
                <p className="form-subtitle">Join our network of trusted partners and grow your business with us.</p>
                <form className="partner-form" onSubmit={handleSubmit}>
                  <div className="form-group">
                    <label>Company Name *</label>
                    <input type="text" name="companyName" value={formData.companyName} onChange={handleChange} required placeholder="Your company name" />
                  </div>
                  <div className="form-group">
                    <label>Contact Person *</label>
                    <input type="text" name="contactPerson" value={formData.contactPerson} onChange={handleChange} required placeholder="Full name" />
                  </div>
                  <div className="form-row">
                    <div className="form-group">
                      <label>Email *</label>
                      <input type="email" name="email" value={formData.email} onChange={handleChange} required placeholder="email@company.com" />
                    </div>
                    <div className="form-group">
                      <label>Phone *</label>
                      <input type="tel" name="phone" value={formData.phone} onChange={handleChange} required placeholder="07XX XXX XXX" />
                    </div>
                  </div>
                  <div className="form-group">
                    <label>Area of Partnership *</label>
                    <select name="partnershipArea" value={formData.partnershipArea} onChange={handleChange} required>
                      <option value="">Select partnership area</option>
                      {partnershipAreas.map((area) => (
                        <option key={area} value={area}>{area}</option>
                      ))}
                    </select>
                  </div>
                  <div className="form-group">
                    <label>About Your Company</label>
                    <textarea name="companyDescription" value={formData.companyDescription} onChange={handleChange} rows="3" placeholder="Tell us about your company and how we can work together..."></textarea>
                  </div>
                  <button type="submit" className="submit-partner-btn">Submit Request</button>
                </form>
              </>
            )}
          </div>
        </div>
      )}
      
      {/* Golden Line at Bottom */}
      <div className="partners-golden-line"></div>
    </section>
  );
};

export default Partners;
